'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

// Segment and PostHog are initialized in instrumentation-client.ts
export default function Analytics() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const analytics = (window as any).analytics
    analytics?.page?.()
  }, [pathname, searchParams])

  return null
}
